<template>
  <div id="faq">
    <info-block :title="$getModuleTitle(currentEvent.modules, 'QuestionLibrary')" :desc="$t('networking.description')" :button="null" :url="null">
      <template slot="input">
        <el-input
          v-model="searchTerm"
          :placeholder="$t('search')"
          :loading="$store.state.eventLoading == 'faqs'"
          :suffix-icon="$store.state.eventLoading == 'faqs' ? 'el-icon-loading' : 'el-icon-search'"
          @clear="
            searchTerm = null;
            $store.dispatch('getFaqs', { searchTerm: null, id: currentEvent.id, route: false });
          "
          clearable
        >
        </el-input>
      </template>
    </info-block>

    <Nodata :title="$getModuleTitle(currentEvent.modules, 'QuestionLibrary')" :description="categoryId == null && searchTerm == null && searchTerm != '' ? $t('contentNotFound') : $t('contentFilterNotFound')" anim="holacon-faq-lottie" :loading="loading == 'refresh'" v-if="currentFaqs.length == 0" :button="$t('refresh')" @btnClick="refresh" />
    <div class="faq-area">
      <div class="faq-item" v-for="item in currentFaqs" :key="item.id" @click="item.collapse = !item.collapse">
        <div class="faq-item-title">
          <span>{{ item.title }}</span>
          <i class="fas fa-chevron-down" :class="{ active: item.collapse }"></i>
        </div>
        <transition name="el-zoom-in-top">
          <div class="faq-item-collapse" v-html="item.details" v-if="item.collapse" :key="item.id + '-collapse'"></div>
        </transition>
      </div>
    </div>
    <!-- <el-collapse accordion class="accordion" v-model="activeFaq">
        <el-collapse-item :name="index" v-for="(item, index) in currentFaqs" :key="item.id">
          <template slot="title"><div class="accordion-header">{{ item.title }}</div></template>
          <div class="accordion-inner" v-html="item.details"></div>
        </el-collapse-item>
      </el-collapse> -->
  </div>
</template>

<script>
import InfoBlock from "../../modules/InfoBlock.vue";
export default {
  name: "FaqComponent",
  components: {
    InfoBlock
  },
  data() {
    return {
      activeFaq: 0,
      searchTerm: null,
      categoryId: null,
      loading: false,
      timeout: null
    };
  },
  methods: {
    async refresh() {
      this.loading = "refresh";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        this.searchTerm = null;
        await this.$store.dispatch("getFaqs", { searchTerm: this.searchTerm, id: this.currentEvent.id, route: false });
        this.loading = false;
      }, 500);
    },
    searchFilter() {
      if(this.timeout != null) clearTimeout(this.timeout);
      if (this.searchTerm != null ) {
        this.timeout = setTimeout(() => {
          this.$store.dispatch("getFaqs", { searchTerm: this.searchTerm, id: this.currentEvent.id, route: false });
        }, 1000);
      }
    }
  },
  async mounted() {
    this.$nextTick(async () => {
      await this.$store.dispatch("getFaqs", { id: this.currentEvent.id, route: false });
    });
  },
  computed: {
    currentEvent() {
      return this.$store.getters.getEvent;
    },
    currentFaqs() {
      return this.$store.getters.getFaqs;
    }
  },
  watch: {
    searchTerm: async function() {
      await this.searchFilter();
    }
  }
};
</script>

<style lang="less">
#faq {
  width: 100%;
  .faq-area  {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    .faq-item {
      padding: 20px;
      box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
      background: white;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      cursor: pointer;
      .faq-item-title {
        display: flex;
        align-items: center;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        justify-content: space-between;
        & > i {
          flex-shrink: 0;
          margin-left: 10px;
          transition: all 0.4s;
          &.active {
            transform: rotate(-90deg);
          }
        }
      }
      .faq-item-collapse {
        & > p,
        h1,
        h2,
        h3,
        h4,
        h5,
        span {
          margin: 0;
          height: auto;
        }
      }

      a {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        max-width: 99%;
        word-wrap: break-word;
        display: inline-block;
        vertical-align: bottom;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/event/Faq.vue